import { RouteType } from "types/RouteType";
import InternalMeetingsStore from "./InternalMeetingsStore";

const internalMeetingsRoute: RouteType[] = [
  {
    name: "InternalMeetings",
    path: "/internal-meetings",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Internal Meetings",
        enableRefreshButton: true,
        component: () => import("./InternalMeetings.Header"),
      },
      body: {
        component: () => import("./InternalMeetings.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    // The words someone types when they cannot remember the page's name. "no
    // client" is the defining fact of an internal meeting, and the one an
    // operator is most likely to search on.
    searchAliases: ["internal", "internal meetings", "no client"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.internalMeetingsStore as InternalMeetingsStore;
      store?.load();
    },
    onExit: ({ rootStore }) => {
      // Tear down the live subscription so the socket handler doesn't leak.
      (rootStore.internalMeetingsStore as InternalMeetingsStore)?.dispose();
    },
  },
];

export default internalMeetingsRoute;
